import React from "react";
import "./NotFoundPage.css";
import StartImage from './../img/svg/Papierflieger.svg';

export default function NotFoundPage() {
    return(
        <div className={window.innerWidth < 426 ? "full-container full-container-mobil" : "full-container"}>
            <div className="message-container">
                <h1 className="mediathek-h1">404</h1>
                <h2 className="mediathek-h2">Leider wurde die gewünschte<br></br>Seite nicht gefunden.</h2> 
                <div className="cta-container">
                    <a href="mailto:hf015@hdm-stuttgart.de"><button className="cta">FEHLER MELDEN</button></a>
    <a href="/mediathek"><button className="cta"><img className="home-icon" src={StartImage}></img>ZURÜCK ZUR HOMEPAGE</button></a>
                </div>
            </div>
        </div>
    );
}